"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _solarReact = require("@solar/solar-react");

var _UnitCard = _interopRequireDefault(require("./UnitCard"));

var _excluded = ["units", "openUnit"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UnitList = function UnitList(_ref) {
  var units = _ref.units,
      openUnit = _ref.openUnit,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_solarReact.CardList, _extends({
    items: (0, _ramda.sortBy)((0, _ramda.prop)('name'))(units)
  }, other), function (_ref2) {
    var _id = _ref2._id,
        key = _ref2.key,
        name = _ref2.name,
        location = _ref2.location,
        primaryContact = _ref2.primaryContact;
    var contactProps = primaryContact ? {
      contactAvatar: primaryContact.avatar && primaryContact.avatar.src,
      contactName: primaryContact.fullName,
      email: primaryContact.email
    } : {};
    return /*#__PURE__*/_react["default"].createElement(_UnitCard["default"], _extends({
      name: "".concat(key, ". ").concat(name),
      address: location ? location.formatted_address : '',
      onOpen: function onOpen() {
        return openUnit(_id);
      }
    }, contactProps));
  });
};

UnitList.propTypes = {
  openUnit: _propTypes["default"].func,
  units: _propTypes["default"].array
};
var _default = UnitList;
exports["default"] = _default;